import { Container, Divider, Typography } from "@mui/material";
import Grid from "../components/Grid";
import Flexbox from "../components/Flexbox";
import Spacebox from "../components/Spacebox";
import Button from "../components/Button";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import { isMobile } from "react-device-detect";
import HomeHeader from "../components/home-header";

const Home = ({ title }) => {
    document.querySelector('title').innerHTML = title

    const navigate = useNavigate()

    const reasons = [
        {
            image: 'fast-funding.svg',
            heading: 'Fast Funding',
            content: 'Get funded in as little as 24-48 hours with our streamlined process',
            items: [
                'Quick application process',
                'Minimal documentation required',
                'Same-day approval possible'
            ]
        },
        {
            image: 'secure.svg',
            heading: 'Secure & Trusted',
            content: 'Bank-level security with transparent terms and no hidden fees',
            items: [
                '256-bit encryption',
                'SOC 2 Type II compliant',
                'Transparent fee structure'
            ]
        },
        {
            image: 'growth.svg',
            heading: 'Growth Focused',
            content: 'Tailored funding solutions designed to accelerate your business growth',
            items: [
                'Flexible payment terms',
                'Scale funding as you grow',
                'Strategic growth planning'
            ]
        },
        {
            image: 'high-approval.svg',
            heading: 'High Approval Rate',
            content: 'AI-powered underwriting that looks beyond traditional credit scores',
            items: [
                'Multiple approval factors',
                'Alternative data analysis',
                'Holistic business evaluation'
            ]
        },
    ]

    const solutions = [
        {
            image: 'established-businesses.svg',
            heading: 'Established Businesses',
            content: 'Scale your operations with flexible funding solutions designed for growing companies.',
            items: [
                'Up to $500,000 in funding',
                'Competitive rates based on business history',
                'Fast approval for qualified businesses'
            ]
        },
        {
            image: 'small-businesses.svg',
            heading: 'Small Businesses',
            content: 'Get the working capital you need to take your small business to the next level.',
            items: [
                'Funding options for various credit profiles',
                'Simple application process',
                'Dedicated support team'
            ]
        },
        {
            image: 'startups.svg',
            heading: 'Startups',
            content: 'Launch and grow your startup with funding solutions tailored for new ventures.',
            items: [
                'Special programs for early-stage companies',
                'Flexible repayment terms',
                'Growth-focused funding options'
            ]
        },
        {
            image: 'e-commerce.svg',
            heading: 'E-commerce',
            content: 'Power your online business with funding solutions designed for digital commerce.',
            items: [
                'Inventory financing available',
                'Revenue-based funding options',
                'Integration with major platforms'
            ]
        },
    ]

    const what_we_do = [
        {
            title: 'Personal Loans',
            sub: 'Fixed amount lump sum loans...',
        },
        {
            title: 'Personal Credit Cards',
            sub: 'Revolving lines of credit for individual...',
        },
        {
            title: 'Business Loans',
            sub: 'Structured Capital provided for Growth...',
        },
        {
            title: 'Business Credit Cards',
            sub: 'Revolving credit accounts given...',
        },
        {
            title: 'Business line of credit',
            sub: 'A Flexible funcing arrangment...',
        },
        {
            title: 'SBA loan program',
            sub: 'Government Backed loans for Bussinesses...',
        },
        {
            title: 'Revenue Based Financing',
            sub: 'A funding method where capital is provided...',
        },
        {
            title: 'Equity Based Funding',
            sub: 'Raising capital by sharing ownership...',
        },
    ]

    return (
        <div className="home-page">
            <section>
                <Flexbox justifyContent="flex-start" alignItems="flex-start" style={{ minHeight: '90dvh', width: isMobile ? '100%' : 'calc(100dvw - 40px)', background: '#4a45e0', margin: '10px auto', borderRadius: '20px', color: 'white' }}>
                    <div style={{ margin: '10px auto' }}>
                        <div style={{ background: 'white', padding: isMobile ? '0px' : '10px', borderRadius: '50px', color: '#000', overflow: 'hidden', width: isMobile ? '90dvw' : '95dvw', margin: 'auto' }}>
                            <HomeHeader />
                        </div>
                        <Container style={{ marginTop: '10dvh' }}>
                            <Grid grid={isMobile ? 1 : 2} gap="10px">
                                <div>
                                    <Spacebox padding="20px" />
                                    <Typography variant="h3" style={{ textAlign: 'left', fontSize: isMobile ? '40px' : '3.6em' }}>
                                        YOUR <b style={{ color: '' }}>CUSTOMIZED <br />
                                            FUNDING SOLUTION</b>
                                    </Typography>
                                    <Spacebox padding="10px" />
                                    <Typography style={{ textAlign: 'left' }}>
                                        Smart Business Funding Made <span style={{ color: '' }}>Simple</span>
                                    </Typography>
                                    <Spacebox padding="10px" />
                                    <Spacebox padding="20px" />
                                    <Flexbox alignItems="center" justifyContent="flex-start">
                                        <Button className="hide-on-mid-and-small" style={{ borderRadius: '5px', padding: '20px 50px', backgroundColor: '#fff', color: 'white' }} handleClick={() => navigate('/apply')}>
                                            <Flexbox alignItems="center">
                                                <b style={{ fontSize: '20px', color: 'var(--primary)' }}>Start Your Journey Today</b>
                                                <Spacebox padding="10px" />
                                                <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(0)' }} />
                                            </Flexbox>
                                        </Button>
                                        <Button className="hide-on-large-only" style={{ borderRadius: '5px', padding: '20px 0px', backgroundColor: 'white', color: 'white', width: '100%' }} handleClick={() => navigate('/apply')}>
                                            <b style={{ fontSize: '20px', color: 'var(--primary)' }}>Start Your Journey Today</b>
                                        </Button>
                                    </Flexbox>
                                    <Spacebox padding="20px" />
                                </div>
                                <Flexbox className="hide-on-mid-and-small" alignItems="center" justifyContent="center">
                                    <img src="/assets/dollar-sign-3d.png" alt="dollar" style={{ width: '100%' }} />
                                </Flexbox>
                            </Grid>
                            <Spacebox padding="10px" />
                            <Typography>What we do</Typography>
                            <Spacebox padding="5px" />
                            {isMobile && <span>
                                We specialize in consulting clients on a wide range of personal and business funding solutions, including but not limited to:
                            </span>}
                            {!isMobile && <span>
                                We specialize in consulting clients on a wide range of personal <br />
                                and business funding solutions, including but not limited to:
                            </span>}
                            <Spacebox padding="10px" />
                            <Grid grid={isMobile ? 1 : 4} gap="10px">
                                {what_we_do.map((service, i) => (
                                    <div key={i} style={{ borderRadius: '10px', backgroundColor: 'white', padding: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', overflow: 'hidden', position: 'relative' }}>
                                        <div>
                                            <Typography style={{ fontSize: '20px'}}>
                                                <b style={{ color: 'black' }}>{service.title}</b>
                                            </Typography>
                                            <Spacebox padding="5px" />
                                            <small style={{ color: 'black', opacity: .5 }}>{service.sub}</small>
                                        </div>
                                        <Spacebox padding="20px" />
                                        <Link to="/about"><u>View more</u></Link>
                                        <img style={{ width: '100px', position: 'absolute', bottom: '-10px', right: '-20px'}} src={`/assets/${(service.title).toString().toLowerCase().replaceAll(' ', "-")}.png`} alt={service.title} />
                                    </div>
                                ))}
                            </Grid>
                            <Spacebox padding="20px" />
                        </Container>
                    </div>
                </Flexbox>
            </section>
            <section>
                <Flexbox alignItems="center" justifyContent="center">
                    <div>
                        <Flexbox alignItems="center" justifyContent="center">
                            <Flexbox alignItems="center" justifyContent="center" style={{ display: 'inline-block', padding: '10px', backgroundColor: '#4A3FFF20', borderRadius: '5px' }}>
                                <img src="/svgs/badge.svg" alt="badge" />
                            </Flexbox>
                        </Flexbox>
                        <Spacebox padding="10px" />
                        <Container>
                            <Typography variant="h4" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px' }}>
                                Why Choose Fund Genies ?
                            </Typography>
                            <Spacebox padding="10px" />
                            <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                                We combine cutting-edge technology with financial expertise to provide the <br />best funding solutions for your business
                            </Typography>
                            <Spacebox padding="20px" />
                            <Grid grid={isMobile ? 1 : 2} gap="20px">
                                {reasons.map((reason, index) => (
                                    <div key={index} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                        <Flexbox alignItems="flex-start">
                                            <div className="hide-on-mid-and-small" style={{ width: 'fit-content', borderRadius: '5px', background: '#4A3FFF10', padding: '15px' }}>
                                                <img src={`/svgs/${reason.image}`} alt={reason.heading} style={{ width: '20px' }} />
                                            </div>
                                            <Spacebox className="hide-on-mid-and-small" padding="10px" />
                                            <div>
                                                <div className="hide-on-large-only margin-auto" style={{ width: 'fit-content', borderRadius: '5px', background: '#4A3FFF10', padding: '15px' }}>
                                                    <img src={`/svgs/${reason.image}`} alt={reason.heading} style={{ width: '20px' }} />
                                                </div>
                                                <Spacebox className="hide-on-large-only" padding="10px" />
                                                <Typography>
                                                    <b>
                                                        {reason.heading}
                                                    </b>
                                                </Typography>
                                                <Spacebox padding="10px" />
                                                <span style={{ opacity: .6 }}>
                                                    {reason.content}
                                                </span>
                                                <Spacebox padding="10px" />
                                                {reason.items.map((item, i) => (
                                                    <Flexbox key={i} style={{ marginBottom: '7px' }}>
                                                        <img src="/svgs/check.svg" alt="check" style={{ width: '14px' }} />
                                                        <Spacebox padding="10px" />
                                                        <small>{item}</small>
                                                    </Flexbox>
                                                ))}
                                            </div>
                                        </Flexbox>
                                    </div>
                                ))}
                            </Grid>
                            <Spacebox className="hide-in-mid-and-small" padding="20px" />
                            <Flexbox alignItems="center" justifyContent="center">
                                <Button className="" style={{ borderRadius: '5px', padding: '15px 40px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/apply')}>
                                    <Flexbox alignItems="center">
                                        <b style={{ fontSize: '18px' }}>Get Started Now</b>
                                        <Spacebox padding="10px" />
                                        <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                    </Flexbox>
                                </Button>
                            </Flexbox>
                        </Container>
                        <Spacebox padding="20px" />
                    </div>
                </Flexbox>
            </section>

            {/* SOLUTIONS FOR EVERY BUSSINESS */}
            {false && <section>
                <Flexbox justifyContent="center" alignItems="center">
                    <div>
                        <Spacebox padding="20px" />
                        <Container>
                            <Flexbox alignItems="center" justifyContent="center">
                                <div style={{ padding: '10px', background: '#4A3FFF10', borderRadius: '5px', }}>
                                    <img src="/svgs/star.svg" alt="star" />
                                </div>
                            </Flexbox>
                            <Spacebox padding="10px" />
                            <Typography variant="h4" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px' }}>
                                Solutions for <b style={{ color: '#4A3FFF' }}>Every</b> Business
                            </Typography>
                            <Spacebox padding="10px" />
                            <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                                Whether you're just starting out or looking to expand, we have the right <br />funding solution for your business needs.
                            </Typography>
                            <Spacebox padding="20px" />
                            <Grid grid={isMobile ? 1 : 2} gap="20px">
                                {solutions.map((solution, index) => (
                                    <div key={index} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                        <Flexbox alignItems="center">
                                            <div style={{ width: 'fit-content', borderRadius: '5px', background: '#4A3FFF10', padding: '15px' }}>
                                                <img src={`/svgs/${solution.image}`} alt={solution.heading} style={{ width: '20px' }} />
                                            </div>
                                            <Spacebox padding="10px" />
                                            <Typography>
                                                <b>
                                                    {solution.heading}
                                                </b>
                                            </Typography>
                                        </Flexbox>
                                        <Spacebox padding="10px" />
                                        <span style={{ opacity: .6 }}>
                                            {solution.content}
                                        </span>
                                        <Spacebox padding="10px" />
                                        <Divider style={{ opacity: .6 }} />
                                        <Spacebox padding="10px" />
                                        {solution.items.map((item, i) => (
                                            <Flexbox key={i} style={{ marginBottom: '8px' }}>
                                                <img src="/svgs/check.svg" alt="check" style={{ width: '14px' }} />
                                                <Spacebox padding="10px" />
                                                <small style={{ opacity: .6 }}>{item}</small>
                                            </Flexbox>
                                        ))}
                                        <Spacebox padding="10px" />
                                        <Button className="" style={{ borderRadius: '5px', padding: '10px 60px', backgroundColor: 'transparent', color: '#000000', border: '1px solid #00000030' }} handleClick={() => navigate('/book')}>
                                            <Flexbox alignItems="center">
                                                <small style={{ fontSize: '18px' }}>Learn More</small>
                                                <Spacebox padding="10px" />
                                                <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '15px' }} />
                                            </Flexbox>
                                        </Button>
                                    </div>
                                ))}
                            </Grid>
                        </Container>
                        <Spacebox padding="20px" />
                    </div>
                </Flexbox>
            </section>}

            {/* READY TO GROW YOUR BUSSINESS */}
            {false && <section>
                <Flexbox alignItems="center" justifyContent="center">
                    <div>
                        <Spacebox padding="20px" />
                        <Container>
                            <div style={{ border: '1px solid #4A3FFF20', borderRadius: '10px', padding: isMobile ? '15px' : '30px' }}>
                                <Spacebox className="hide-on-mid-and-small" padding="20px" />
                                <Flexbox alignItems="center" justifyContent="center">
                                    <div>
                                        <Flexbox alignItems="center" justifyContent="center">
                                            <img src="/svgs/star.svg" alt="star" style={{ width: '20px' }} />
                                        </Flexbox>
                                        <Spacebox padding="10px" />
                                        <Typography variant="h4" style={{ textAlign: 'center', fontSize: '30px' }}>
                                            Ready to Grow Your Business?
                                        </Typography>
                                        <Spacebox padding="10px" />
                                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                                            Book your free consultation today and discover how much funding you <br />qualify for.
                                        </Typography>
                                        <Spacebox padding="20px" />
                                        <Grid grid={isMobile ? 1 : 2} gap="20px">
                                            <Button className="hide-on-mid-and-small" style={{ borderRadius: '5px', padding: '20px 50px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/book')}>
                                                <Flexbox alignItems="center">
                                                    <b style={{ fontSize: '20px' }}>Book Free Consultation</b>
                                                    <Spacebox padding="10px" />
                                                    <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                                </Flexbox>
                                            </Button>
                                            <Button className="hide-on-mid-and-small" style={{ borderRadius: '5px', padding: '20px 50px', backgroundColor: 'transparent', border: '1px solid #00000020', color: 'black', width: 'fit-content' }} handleClick={() => { }}>
                                                <Flexbox alignItems="center">
                                                    <b style={{ fontSize: '20px' }}>Learn More</b>
                                                    <Spacebox padding="10px" />
                                                    <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px' }} />
                                                </Flexbox>
                                            </Button>
                                            <Button className="hide-on-large-only" style={{ borderRadius: '5px', padding: '20px 0px', backgroundColor: 'var(--primary)', color: 'white', width: '100%' }} handleClick={() => navigate('/book')}>
                                                <b style={{ fontSize: '20px' }}>Book Free Consultation</b>
                                            </Button>
                                        </Grid>
                                    </div>
                                </Flexbox>
                                <Spacebox className="hide-on-mid-and-small" padding="20px" />
                            </div>
                        </Container>
                        <Spacebox padding="20px" />
                    </div>
                </Flexbox>
            </section>}
            <Footer />
        </div>
    );
}

export default Home;